import React, { useState, useEffect } from "react";
import Modal from "react-bootstrap/Modal";
import Button from "react-bootstrap/Button";
import FormInputs from "../../../../components/UI/FormInputs";
 
const DynamicFormModal = ({ isOpen, onClose, title, fields, onSubmit,Toast }) => {
  console.log("title",title,"fields",fields)
  const [formData, setFormData] = useState({});
 
  useEffect(() => {
    const initialData = {};
    fields.forEach((f) => {
      initialData[f.name] = f.defaultValue || "";
    });
    setFormData(initialData);
  }, [fields]);
 
  const changeHandler = (val, name) => {
    console.log("val,name",val,name);
    setFormData((prev) => ({
      ...prev,
      [name]: val,
    }));
  };
 
  const handleSubmit = () => {
    // ✅ Validation check
    const allFilled = fields.every(
      (field) => formData[field.name] !== "" && formData[field.name] !== null
    );

    if (!allFilled) {
      Toast.error("All Field Required");
      return;
    }

    onSubmit(formData);
    onClose();
  };
 
  return (
    <Modal show={isOpen} onHide={onClose} backdrop="static" size="lg">
      <Modal.Header closeButton>
        <Modal.Title>
          <h6 className="text-lg mb-0 font-weight-bold">{title}</h6>
        </Modal.Title>
      </Modal.Header>
      <Modal.Body>
        <div className="row">
          {fields.map((field, index) => (
            <div className="col-6" key={index}>
              <div className="form-group">
                <label className="mb-0 text-md opacity-75">{field.label}</label>
                <FormInputs
                  {...field}
                  value={formData[field.name] || ""}
                  changeHandler={(val) => changeHandler(val, field.name)}
                />
              </div>
            </div>
          ))}
        </div>
      </Modal.Body>
      <Modal.Footer className="d-flex justify-content-center">
        <Button variant="primary" onClick={handleSubmit}>Submit</Button>
      </Modal.Footer>
    </Modal>
  );
};
 
export default DynamicFormModal;